// ConfirmDeleteModal.tsx
import React from "react";
import DeleteEntityModal from "@pages/Program/components/DeleteEntity"; // adjust path if needed

export interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entityNames: string[] | string;
  /** optional: show spinner on confirm button while deleting */
  isLoading?: boolean;
}

/**
 * Thin adapter around the project's nicer DeleteEntityModal,
 * preserving the old ConfirmDeleteModal API so you don't have to
 * change any calling code.
 */
const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  entityNames,
  isLoading = false,
}) => {
  const label = Array.isArray(entityNames)
    ? entityNames.length > 1
      ? `${entityNames.length} files`
      : entityNames[0] ?? "this item"
    : entityNames ?? "this item";

  // DeleteEntityModal expects a "selectedEntity" to read .name/.title
  const selectedEntity = { name: label };

  return (
    <DeleteEntityModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      selectedEntity={selectedEntity as { name?: string; title?: string }}
      titleText="Are you sure you want to delete"
      detailsText="This action will permanently delete this item(s) and any associated data. This cannot be undone."
      confirmText="Delete"
      isLoading={isLoading}
      // Optional: tweak styles if you want
      cancelClassName=""
      confirmClassName=""
    />
  );
};

export default ConfirmDeleteModal;
